export const timeOfDay = [
  { start: '9am', end: '11am', value: '9am to 11am' },
  { start: '11am', end: '1pm', value: '11am to 1pm'},
  { start: '1pm', end: '3pm', value: '1pm to 3pm'},
  { start: '3pm', end: '5pm', value: '3pm to 5pm'}
]
